import React, { useRef, useEffect, useState } from 'react';
import { createMuiTheme, jssPreset, ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { AiFillCaretDown } from '@react-icons/all-files/ai/AiFillCaretDown';
import { create } from 'jss';
import Cookies from 'js-cookie';
import rtl from 'jss-rtl';
import { FormattedMessage, useIntl } from 'react-intl';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { MdGpsFixed } from '@react-icons/all-files/md/MdGpsFixed';
const { handleCountryPopup, selectDesktop } = Slices.appSlice;
import css from './index.module.scss';
import CountrySelection from '../CountryDropdown';

function SelectStore({
  mode,
  citiesData,
  selectedCity,
  setSelectedCity,
  handleStore,
  openStore,
  setOpenStore,
  storeList,
  selectedStoreObj,
  selectStore,
  setSelectedStore,
  getCurrentLocation,
  setStoreSelection,
}) {
  const intl = useIntl();
  const [cityOpen, setCityOpen] = useState(false);
  const ltrTheme = createMuiTheme({ direction: 'ltr' });
  const rtlTheme = createMuiTheme({ direction: 'rtl' });
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const myRef = useRef(null);
  const storeRef = useRef(null);
  const storeInputRef = useRef(null);
  const dispatch = useDispatch();
  const isDesktop = useSelector(selectDesktop);
  const isRtl = Cookies.get('local') === 'ar' ? rtlTheme : ltrTheme;
  openStore && document.getElementById('store').focus();

  const executeScroll = (loc) => () => {
    if (!isDesktop) {
      window.scrollTo(0, 800);
    }
  };
  const onBlurClose = (loc) => () => {
    setOpenStore(false);
  };
  const openStoreVal = (loc) => () => {
    if (!isDesktop) {
      window.scrollTo(0, 800);
    }
    setOpenStore(true);
  };
  useEffect(() => {
    if (!isDesktop) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const openPopup = (e) => {
    e.preventDefault();
    dispatch(handleCountryPopup());
  };
  const Link = ({ children, ...other }) => (
    <Paper {...other}>
      {children}
      <div
        className={css.changeButton}
        onMouseDown={(event) => openPopup(event)}
        rel="nofollow"
        target="_blank"
      >
        <CountrySelection onlyChangeButton={true} />
      </div>
    </Paper>
  );
  useEffect(() => {
    if (storeList.length > 0 && openStore) {
      storeInputRef.current.focus();
    }
  }, [storeList, openStore]);
  return (
    <div className={css.root}>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={isRtl}>
          <div className={css.citySelectorContainer}>
            <div className={css.onlyFlag}>
              <CountrySelection showCountryDropDown={false} showName={false} />
            </div>
            <div className={css.autoSelector}>
              <Autocomplete
                closeIcon={<IoMdClose />}
                ref={myRef}
                id="city"
                fullWidth={false}
                options={citiesData}
                onOpen={executeScroll('city')}
                noOptionsText={intl.formatMessage({ id: 'NO_OPTIONFOUND' })}
                getOptionLabel={(option) => option.title}
                value={selectedCity || null}
                getOptionSelected={(option, value) => option.title === value.title}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === 'reset') {
                    setSelectedCity(null);
                    setStoreSelection(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={css.input_city}
                    placeholder={intl.formatMessage({ id: `${mode}_city` })}
                  />
                )}
                onChange={handleStore}
                PaperComponent={Link}
              />
            </div>
          </div>
          <Autocomplete
            disabled={storeList.length <= 0}
            ref={storeRef}
            open={openStore}
            id="store"
            onOpen={openStoreVal('store')}
            onClose={() => setOpenStore(false)}
            onBlur={onBlurClose('store')}
            clearOnBlur={true}
            noOptionsText={intl.formatMessage({ id: 'NO_OPTIONFOUND' })}
            options={storeList}
            getOptionLabel={(option) => option.title}
            value={selectedStoreObj || null}
            onClick={() => setOpenStore(true)}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === 'reset') {
                setSelectedStore(null);
                setStoreSelection(null);
              }
            }}
            getOptionSelected={(option, value) => option.title === value.title}
            renderInput={(params) => (
              <TextField
                className={css.input}
                inputRef={storeInputRef}
                {...params}
                placeholder={intl.formatMessage({ id: `${mode}_store` })}
              />
            )}
            onChange={selectStore}
          />
        </ThemeProvider>
      </StylesProvider>
      <Button
        className={css.locButton}
        onClick={getCurrentLocation}
        fullWidth
        variant="outlined"
        color="primary"
        size="large"
      >
        <MdGpsFixed />
        <FormattedMessage id={`${mode}_location`} defaultMessage="Use my location" />
      </Button>
    </div>
  );
}

export default SelectStore;
